import React, { useEffect, useState } from 'react';

/** 
 * Required css & jss assett
 */
import './assets/css/style.css';//css
//import './assets/css/childhood-rescue-donate.css';//css
//import './assets/js/style.js';
//import './assets/js/helpers.js';
/**
 * Parts
 */
import Header from './components/parts/Header';
import Footer from './components/parts/Footer';
/**
 * Main Router
*/
import MainRoutes from './routes/Routes';


function App() {
  return (
    <div className="App">
      <Header />

      <MainRoutes />{/* All pages can be manage inside this components */}

      <Footer />
    </div>
  );
}

export default App;
